// extracted by mini-css-extract-plugin
export var resizer = "_i1-0";